import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import styles from './FilterToggleGroup.module.scss';

/**
 * Labelled segmented control for filter bars: the notch label says what is being
 * switched, so the buttons themselves stay short.
 * `options` is `[{ value, label, ariaLabel, disabled }]`.
 */
const FilterToggleGroup = ({
    label,
    value,
    onChange,
    options = [],
    direction = 'rtl',
    className = '',
    ariaLabel,
}) => (
    <div className={`${styles.wrap} ${direction === 'ltr' ? styles.ltr : ''} ${className}`} dir={direction}>
        {label ? <span className={styles.label}>{label}</span> : null}
        <ToggleButtonGroup
            className={styles.group}
            value={value}
            exclusive
            onChange={onChange}
            size="small"
            aria-label={ariaLabel || label}
        >
            {options.map((option) => (
                <ToggleButton
                    key={String(option.value)}
                    value={option.value}
                    disabled={option.disabled}
                    aria-label={option.ariaLabel || String(option.value)}
                >
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    </div>
);

export default FilterToggleGroup;
